import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mask',
  standalone: false,
})
export class MaskPipe implements PipeTransform {
  transform(value: string, maskOptions: string): string {
    if (!value) return '';

    const masks = maskOptions.split(' || ').map(m => m.trim());

    let selectedMask = '';
    for (const mask of masks) {
      const digitCount = mask.split('0').length - 1;

      if (value.length === digitCount) {
        selectedMask = mask;
        break;
      }
    }

    if (!selectedMask && masks.length > 0) {
      selectedMask = masks[0];
    }

    let formattedValue = '';
    let index = 0;

    for (let i = 0; i < selectedMask.length; i++) {
      if (selectedMask[i] === '0') {
        if (index < value.length) {
          formattedValue += value[index];
          index++;
        } else {
          break;
        }
      } else {
        formattedValue += selectedMask[i];
      }
    }

    return formattedValue;
  }
}
